<template>
    <div>
        <div class="loader-wrapper" v-if="isLoading">
            <img src="@/assets/spin-loader.gif" alt="ładowanie...">
        </div>
        <div class="month-preview-container">
            <button @click="() => {$router.push('/zlecenia')}" class="btn btn-primary align-self-start">powrót</button>
            <h1>Przeglądaj miesiąc</h1>
            <form class="d-flex mt-3" @submit="(e) => searchTasks(e)">
                <input type="text" class="form-control" placeholder="wpisz szukaną frazę" v-model="searchTaskInput">
                <button type="submit" class="btn btn-success mx-3">szukaj</button>
                <button type="button" @click="resetSearchForm" class="btn btn-primary">resetuj</button>
            </form>
        </div>
        <div  class="p-1 mt-3 table-responsive" style="min-width: 2500px; overflow: visible;" v-if="$store.getters.getexportMonth.month !== '' && $store.getters.getexportMonth.year !== ''">
            <table class="table">
                <thead>
                    <tr class="">
                        <th>Numer Przejazdu</th>
                        <th>Nazwa firmy</th>
                        <th>Trasa</th>
                        <th>Załadunek</th>
                        <th>Rozładunek</th>
                        <th>RZGZAŁ</th>
                        <th>RZGROZ</th>
                        <th>Ciągnik</th>
                        <th>Naczepa</th>
                        <th>Kierowca</th>
                        <th>Stawka</th>
                        <th>Waluta</th>
                        <th>Spedytor</th>
                        <th>FV</th>
                        <th>Aplikacja</th>
                        <th>Zabezpieczenie</th>
                        <th>Extra cost case</th>
                        <th>Opis 1</th>
                        <th>Opis 2</th>
                        <th>Opis 3</th>
                    </tr>
                </thead>
                <tbody v-if="tasks.length > 0">
                <template v-for="task in foundTasks.length > 0 ? foundTasks : tasks" :key="task.id">
                  <tr :style="`background-color: ${task.archived ? 'rgba(144, 144, 144, 0.28)' : task.altBackgroundColor ?? '#ffffff'}; color: ${task.altTextColor ?? '#000000'};`" :id="`t${task.id}`">
                    <td>{{ task.numer_Przejazdu }} <div :style="`height: ${task.changes.length*25}px; width: 2px;`"></div></td>
                    <td>{{ task.nazna_Firmy }} <div :style="`height: ${task.changes.length*25}px; width: 2px;`"></div></td>
                    <td>{{ task.trasa }} <div :style="`height: ${task.changes.length*25}px; width: 2px;`"></div></td>
                    <td>{{ task.zaladunek !== undefined ? task.zaladunek.split('T')[0] : '' }} {{ task.zaladunek !== undefined ? task.zaladunek.split('T')[1].split('.')[0] : '' }} <div :style="`height: ${task.changes.length*25}px; width: 2px;`"></div></td>
                    <td>{{ task.rozladunek !== undefined ? task.rozladunek.split('T')[0] : '' }} {{ task.rozladunek !== undefined ? task.rozladunek.split('T')[1].split('.')[0] : '' }} <div :style="`height: ${task.changes.length*25}px; width: 2px;`"></div></td>
                    <td>
                      <span v-if="task.stoppages[0]?.actualArrival">
                        {{ moment(task.stoppages[0].actualArrival).format('DD.MM.YYYY HH:mm') }}
                      </span>
                        <span v-else>
                        Brak informacji
                      </span>
                    </td>
                    <td>
                      <span v-if="task.stoppages.slice(-1)[0]?.actualArrival">
                        {{ moment(task.stoppages.slice(-1)[0].actualArrival).format('DD.MM.YYYY HH:mm') }}
                      </span>
                      <span v-else>
                        Brak informacji
                      </span>
                    </td>
                    <td>{{ task.auto ? task.auto.name : 'Brak' }} <div :style="`height: ${task.changes.length*25}px; width: 2px;`"></div></td>
                    <td>
                      <div v-if="!task.semitrailer" >
                        Brak naczep
                      </div>
                      <div v-else>
                        <div class="trailer-name">
                                    <span>
                                        {{ task.semitrailer.plateNumber }}
                                    </span>
                        </div>
                      </div>
                      <div :style="`height: ${task.changes.length*25}px; width: 2px;`"></div>
                    </td>
                    <td>
                      <DriversOutput :task="task"/>
                      <div :style="`height: ${task.changes.length*25}px; width: 2px;`"></div>
                    </td>
                    <td>{{ task.stawka.toString().replace('.', ',') }} <div :style="`height: ${task.changes.length*25}px; width: 2px;`"></div></td>
                    <td>{{ task.waluta ?? this.actualCurrency }} <div :style="`height: ${task.changes.length*25}px; width: 2px;`"></div></td>
                    <td>
                      <div v-if="task.freightForwarder">{{ task.freightForwarder }}</div> <div v-else>{{ 'brak' }}</div>
                      <div :style="`height: ${task.changes.length*25}px; width: 2px;`"></div>
                    </td>
                    <td>
                      <div v-if="task.fv">{{ task.fv }}</div> <div v-else>{{ 'brak' }}</div>
                      <div :style="`height: ${task.changes.length*25}px; width: 2px;`"></div>
                    </td>
                    <td>
                      <div v-if="task.application">{{ task.application }}</div> <div v-else>{{ 'brak' }}</div>
                      <div :style="`height: ${task.changes.length*25}px; width: 2px;`"></div>
                    </td>
                    <td>
                      <div v-if="task.security">{{ task.security }}</div> <div v-else>{{ 'brak' }}</div>
                      <div :style="`height: ${task.changes.length*25}px; width: 2px;`"></div>
                    </td>
                    <td>
                      <div v-if="task.extraCostCase">{{ task.extraCostCase }}</div> <div v-else>{{ 'brak' }}</div>
                      <div :style="`height: ${task.changes.length*25}px; width: 2px;`"></div>
                    </td>
                    <td>
                      <div v-if="task.description1">{{ task.description1 }}</div> <div v-else>{{ 'brak' }}</div>
                      <div :style="`height: ${task.changes.length*25}px; width: 2px;`"></div>
                    </td>
                    <td>
                      <div v-if="task.description2">{{ task.description2 }}</div> <div v-else>{{ 'brak' }}</div>
                      <div :style="`height: ${task.changes.length*25}px; width: 2px;`"></div>
                    </td>
                    <td>
                      <div v-if="task.description3">{{ task.description3 }}</div> <div v-else>{{ 'brak' }}</div>
                      <div :style="`height: ${task.changes.length*25}px; width: 2px;`"></div>
                    </td>
                  </tr>
                  <ChangeReference :given-task="task" :export-month="true"/>
                </template>
                </tbody>
                <tbody v-else>
                  <div class="fw-bolder">BRAK ZLECEŃ</div>
                </tbody>
            </table>
        </div>
        <div v-else class="mt-3 text-primary">
            <h4>Wróć do panelu zleceń i wybierz rok i miesiąc</h4>
            {{ isLoading = false }}
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import DriversOutput from '@/components/DriversOutput'
import Swal from 'sweetalert2'
import ChangeReference from '@/components/Partials/Changes/VehicleChange/ChangeReference.vue'
import moment from 'moment-timezone'

export default{
    name: "ExportMonth",
    data() {
        return {
            tasks: [],
            months: ['01','02','03','04','05','06','07','08','09','10','11','12'],
            isLoading: true,
            actualCurrency: 'EUR',
            searchTaskInput: '',
            foundTasks: [],
            moment: moment
        }
    },
    components: { ChangeReference, DriversOutput },
    mounted() {
      this.getYearAndMonth()
    },
    methods:{
        getYearAndMonth(){
            const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
            if(document.querySelector('.modal-backdrop')){
                document.querySelectorAll('.modal-backdrop').forEach(x => {
                    x.style = 'display: none;'
                })
            }
            if(document.querySelector('.modal-open')){
                document.querySelector('.modal-open').style = ''
            }

            const monthAndYear = this.$store.getters.getexportMonth
            const from = `${monthAndYear.year}-${monthAndYear.month}-1`
            let to = ''
            if(monthAndYear.month == '12'){
                to = `${Number(monthAndYear.year)+1}-01-1`
            }else{
                to = `${monthAndYear.year}-${this.months[this.months.indexOf(monthAndYear.month)+1]}-1`
            }
            axios.get(`${process.env.VUE_APP_API_BASE_URL}Task/Filtered/Dates?fromDate=${from}&toDate=${to}`, config).then(res => {
                if(String(res.status).charAt(0) === '2'){
                    this.isLoading = false
                    this.tasks = res.data.filter(t => new Date(t.zaladunek).getMonth() + 1 === parseInt(this.months[this.months.indexOf(monthAndYear.month)]))
                    this.sortTasksByDate('zaladunek')
                }
            }).catch(err => {
                console.log(err);
            })
        },
        sortTasksByDate (dateProperty, withOrderingChange = true) {
            if (withOrderingChange) {
                this.isAscOrdering = !this.isAscOrdering
            }

            this.tasks = this.tasks.sort((a, b) => {
                const aDate = new Date(a[dateProperty])
                const bDate = new Date(b[dateProperty])
                if (this.isAscOrdering) {
                return aDate - bDate
                } else {
                return bDate - aDate
                }
            })
        },
        searchTasks (e) {
            e.preventDefault()
            if(this.searchTaskInput.length > 2){
                const searchText = this.searchTaskInput.trim().toLowerCase()
                this.foundTasks = this.tasks.filter(task =>
                    task.nazna_Firmy.toLowerCase().includes(searchText) ||
                    task.numer_Przejazdu.toLowerCase().includes(searchText) ||
                    task.auto?.plateNumber?.toLowerCase()?.includes(searchText) ||
                    task.semitrailer?.plateNumber?.toLowerCase()?.includes(searchText) ||
                    task.kierowcy?.filter(driver => driver.firstName.toLowerCase().includes(searchText) || driver.surname.toLowerCase().includes(searchText)).length > 0 ||
                    task.stoppages?.map(s => s.acronym).join('->').toLowerCase().includes(searchText) ||
                    task.changes?.find(c => c.vehicle.plateNumber.toLowerCase().includes(searchText))
                )
            }else{
                Swal.fire('wpisz przynajmniej 3 znaki', '', 'warning')
            }
        },
        resetSearchForm(){
            this.searchTaskInput = ''
            this.foundTasks.splice(0)
        }
    }
}
</script>

<style scoped>
.month-preview-container{
    display: flex;
    flex-direction: column;
    padding: 20px;
    align-items: center;
    border-bottom: 2px solid #dbdbdb;
}
.loader-wrapper{
    background-color: #0000007a;
    width: 100%;
    height: 100vh;
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
}
.trailer-name {
  font-size: 12px;
  font-weight: 300;
  margin-bottom: 3px;
}
.chPanel{
  position: absolute;
  bottom: 0;
  left:0;
  width: 100%;
  height: auto;
  margin-left: 70px;
  margin-top: 20px;
}
.chPanel > div{
  height: 30px;
  margin: 0;
  padding: 0;
  width: 100%;
  display:flex;
  justify-content: flex-start;
}
tr[id *= 't']{
  position: relative;
}
</style>
